const TOKEN_KEY = "baseball_hub_api_token_v1"

export const tokenStore = {
  get: () => window.localStorage.getItem(TOKEN_KEY),
  set: (token) => window.localStorage.setItem(TOKEN_KEY, token),
  clear: () => window.localStorage.removeItem(TOKEN_KEY),
}

export async function api(path, options = {}) {
  const token = tokenStore.get()
  const headers = { Accept: "application/json", ...options.headers }
  if (options.body && !(options.body instanceof FormData)) headers["Content-Type"] = "application/json"
  if (token) headers.Authorization = `Bearer ${token}`

  const response = await fetch(`/api/v1${path}`, { ...options, headers })
  if (response.status === 204) return null

  const payload = await response.json().catch(() => ({}))
  if (!response.ok) {
    const error = new Error(payload.error || `Request failed (${response.status})`)
    error.details = payload.errors
    error.status = response.status
    throw error
  }
  return payload
}

export async function download(path, fallbackFilename) {
  const token = tokenStore.get()
  const headers = { Accept: "text/csv" }
  if (token) headers.Authorization = `Bearer ${token}`

  const response = await fetch(`/api/v1${path}`, { headers })
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}))
    const error = new Error(payload.error || `Request failed (${response.status})`)
    error.status = response.status
    throw error
  }

  const url = URL.createObjectURL(await response.blob())
  const link = document.createElement("a")
  link.href = url
  link.download = fallbackFilename
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}

export function json(method, body) {
  return { method, body: JSON.stringify(body) }
}

export async function pollJob(statusUrl, { interval = 750, timeout = 360000 } = {}) {
  const startedAt = Date.now()
  while (Date.now() - startedAt < timeout) {
    const payload = await api(statusUrl)
    if (payload.status === "completed" || payload.status === "sent") return payload
    if (payload.status === "failed") throw new Error(payload.error || "Background operation failed")
    await new Promise(resolve => window.setTimeout(resolve, interval))
  }
  throw new Error("The operation is still running. Refresh shortly to see its status.")
}
